import membersStrings from 'modules/members/strings';

const { allTransactions, earnedTransactions, redeemedTransactions } = membersStrings.memberProfile;

export const transactionsTabsOptions = [
  { name: allTransactions, value: null, key: 'All' },
  {
    name: earnedTransactions,
    value: 'Approved',
    matchWith: ['Approved', 'Expired'],
    key: 'Approved',
  },
  { name: redeemedTransactions, value: 'Deducted', matchWith: ['Deducted'], key: 'Deducted' },
];

export const TransactionTypeMapping = {
  Approved: 'Earned',
  Deducted: 'Redeemed',
  Expired: 'Expired',
};

export const searchQueryMinLength = 7;
